import { Outlet } from 'react-router-dom';
import { MobileAppNavigation } from './MobileAppNavigation';

export default function AppShell() {
  return (
    <>
      <div className="h-[72px] md:hidden" aria-hidden="true" />
      <Outlet />
      <MobileAppNavigation />
    </>
  );
}
